import React from 'react';
import { Link } from 'react-router-dom';
import { Moon, Heart, MapPin, Phone, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-navy-900 border-t border-emerald-500/10 mt-20">
      {/* Decorative top border */}
      <div className="h-0.5 bg-gradient-to-r from-transparent via-emerald-500 to-transparent opacity-50" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-emerald-500 to-emerald-700 flex items-center justify-center">
                <Moon className="w-5 h-5 text-white" />
              </div>
              <div>
                <span className="font-bold text-white text-lg leading-tight block">Oldham</span>
                <span className="text-xs text-emerald-400 leading-tight block tracking-wider">PRAYER TIMES</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Your trusted source for accurate prayer times across all mosques in Oldham, Greater Manchester.
            </p>
            <p className="mt-4 text-xs text-emerald-400 font-arabic" style={{ direction: 'rtl' }}>
              بِسْمِ اللهِ الرَّحْمٰنِ الرَّحِيْمِ
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { to: '/', label: 'Home' },
                { to: '/timetables', label: 'Timetables' },
                { to: '/prayers-by-date', label: 'Prayer Times by Date' },
                { to: '/mosques', label: 'Mosque List' },
                { to: '/jummah', label: "Jumu'ah Times" },
              ].map(({ to, label }) => (
                <li key={to}>
                  <Link
                    to={to}
                    className="text-gray-400 hover:text-emerald-400 text-sm transition-colors flex items-center gap-2"
                  >
                    <span className="w-1 h-1 rounded-full bg-emerald-500 inline-block" />
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-sm uppercase tracking-wider">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" />
                <span>Oldham, Greater Manchester, UK</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <Phone className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" />
                <span>Contact individual mosques directly</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <Mail className="w-4 h-4 text-emerald-400 mt-0.5 flex-shrink-0" />
                <a href="mailto:kkhubayb@gmail.com" className="hover:text-emerald-400 transition-colors">kkhubayb@gmail.com</a>
              </li>
            </ul>

            {/* Prayer times badge */}
            <div className="mt-6 inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-emerald-500/10 border border-emerald-500/20">
              <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
              <span className="text-emerald-400 text-xs font-medium">Live Prayer Times</span>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">
            &copy; {new Date().getFullYear()} Oldham Prayer Times. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs flex items-center gap-1">
            Developed with <Heart className="w-3 h-3 text-emerald-500 fill-current" /> by Khubayb Kapila
          </p>
        </div>
      </div>
    </footer>
  );
}
